export default "__VITE_ASSET__DHUDtmnT__"